export function formatAmount(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return value.toLocaleString(undefined, { maximumFractionDigits: 2 });
}

export function formatPercent(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return `${value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`;
}

export function formatVariance(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '—';
  const rounded = value.toLocaleString(undefined, { maximumFractionDigits: 1, signDisplay: 'exceptZero' });
  return `${rounded} pp`;
}
